import React, { createContext } from 'react';
import { ShareOutlined, VideoLibraryOutlined, Group, Lock, Settings } from '@material-ui/icons';
import { ReactComponent as Forms } from '../../../assets/images/forms.svg';
import ColorHub from '../../../reusable/ColorHub/ColorHub';

export namespace MediaDetailUtils {
	export const MenuItems = [
		{
			value: 'detail',
			icon: <VideoLibraryOutlined htmlColor="#000000" />,
			activeIcon: <VideoLibraryOutlined htmlColor="#126cfc" />,
			label: 'Details',
		},
		{
			value: 'share',
			icon: <ShareOutlined htmlColor="#000000" />,
			activeIcon: <ShareOutlined htmlColor="#126cfc" />,
			label: 'Share',
		},
	];
	export const MenuPortalItems = [
		{
			value: 'detail',
			icon: <VideoLibraryOutlined htmlColor="#000000" />,
			activeIcon: <VideoLibraryOutlined htmlColor="#126cfc" />,
			label: 'Details',
		},
		{
			value: 'share',
			icon: <ShareOutlined htmlColor="#000000" />,
			activeIcon: <ShareOutlined htmlColor="#126cfc" />,
			label: 'Share',
		},
		{
			value: 'restrict-access',
			icon: <Lock htmlColor="#000000" />,
			activeIcon: <Lock htmlColor="#126cfc" />,
			label: 'Protected Content',
		},
	];

	export const ExpandMenuItems = [
		{
			value: 'share',
			icon: <ShareOutlined htmlColor="#000000" />,
			activeIcon: <ShareOutlined htmlColor="#126cfc" />,
			label: 'Share',
		},
	];

	export const MenuFormItems = [
		{
			value: 'conversions',
			icon: <Group htmlColor="#000000" />,
			activeIcon: <Group htmlColor="#126cfc" />,
		},
		{
			value: 'detail',
			icon: <ColorHub component={<Forms />} htmlColor="#000000" style={{ padding: '1px 0px' }} />,
			activeIcon: <ColorHub component={<Forms />} htmlColor="#126cfc" style={{ padding: '1px 0px' }} />,
		},
		{
			value: 'setting',
			icon: <ColorHub component={<Settings />} htmlColor="#000000" style={{ padding: '1px 0px' }} />,
			activeIcon: <ColorHub component={<Settings />} htmlColor="#126cfc" style={{ padding: '1px 0px' }} />,
		},
	];

	interface MediaDetailHeaderProps {
		isMediaModified?: boolean;
		setIsMediaModified: (_value: boolean) => void;
	}

	export const MediaDetailHeaderContext = createContext<MediaDetailHeaderProps>({
		setIsMediaModified: (_value) => {},
	});
}
